import { CardActions, CardContent, withStyles } from "@material-ui/core";
import { EditButton, TextField } from "react-admin";
import React, { Fragment } from "react";

import SensorValueField from "../../components/fields/SensorValueField";
import { grey } from "@material-ui/core/colors";

const SensorCard = withStyles((theme) => ({
  header: {
    backgroundColor: theme.palette.secondary.main,
    "& *": {
      color: "white",
    },
  },
  content: {
    backgroundColor: grey[100],
  },
  actions: {
    backgroundColor: grey[100],
  },
}))(({ classes, websocket, ...props }) => (
  <Fragment>
    <CardContent className={classes.content}>
      <TextField {...props} source="name" variant="body2" />
      <SensorValueField {...props} websocket={websocket} />
    </CardContent>
    <CardActions className={classes.actions}>
      <EditButton {...props} />
    </CardActions>
  </Fragment>
));
export default SensorCard;
